import ImageCropper from './image-cropper'

export default ImageCropper
